import { render } from "./AlarmListNew.vue?vue&type=template&id=5738f0a6"
import script from "./AlarmListNew.vue?vue&type=script&lang=js"
export * from "./AlarmListNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__